import React, { Component } from 'react';
import { LinkedinShareButton, TwitterShareButton, LinkedinIcon, WhatsappShareButton, WhatsappIcon } from 'react-share';



class SocialActions extends Component {

    render() {

        // adding x (twitter) icon as SVG because font-awesome v5 doesn't include it
        const XTwitterIcon = (
            <svg viewBox="0 0 64 64" width="32" height="32">
                <circle cx="32" cy="32" r="32" fill="#000000"></circle>
                <path d="M 41.116 18.375 h 4.962 l -10.8405 12.39 l 12.753 16.86 H 38.005 l -7.821 -10.2255 L 21.235 47.625 H 16.27 l 11.595 -13.2525 L 15.631 18.375 H 25.87 l 7.0695 9.3465 z m -1.7415 26.28 h 2.7495 L 24.376 21.189 H 21.4255 z" fill="#ffffff"></path>
            </svg>
        )

        const iconSize = 32;
        const { description, image, url, title } = this.props;

        return (
            <div className="content-body-social">

                {/* 
                  * can't add instagram as it's not supported by Instagram's API
                  * https://github.com/nygardk/react-share/issues/146
                  */}

                <div className="content-social-icon">
                    <TwitterShareButton url={url} image={image} size={iconSize} title={title} description={description} className="icon-twitter">
                        {XTwitterIcon}
                    </TwitterShareButton>
                </div>
                <div className="content-social-icon">
                    <LinkedinShareButton url={url} image={image} size={iconSize} title={title} description={description} className="icon-linkedin">
                        <LinkedinIcon />
                    </LinkedinShareButton>
                </div>
                <div className="content-social-icon">
                    <WhatsappShareButton url={url} title={title} className="icon-whatsapp">
                        <WhatsappIcon />
                    </WhatsappShareButton>
                </div>

            </div>

        )
    }

}

export default SocialActions;